import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getTicketRuleList, getTicketRuleDetail, createTicketRule, updateTicketRule, deleteTicketRule, getCapitalRelationList } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'OilTicketConfig',
  components: {},
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        return formatTimeToStr(time, format || 'yyyy-MM-dd hh:mm:ss');
      }

      return '';
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getOilCodeNames: function getOilCodeNames(oilCodes) {
      oilCodes = oilCodes + '';
      var oilCodeArr = oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    },
    getWeekNames: function getWeekNames(cycleDays) {
      cycleDays = cycleDays + '';
      var arr = cycleDays.split(',');
      var names = '';

      if (arr.length === 0 || arr.length === _this.weekOptions.length) {
        return '不限';
      }

      _this.weekOptions.map(function (o) {
        if (arr.includes(o.value + '')) {
          names += o.label + ',';
        }
      });

      return names.substr(0, names.length - 1);
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getTicketRuleList,
      type: '',
      ruleType: 2,
      ticketTypeOptions: [{
        name: '满减券',
        value: 1
      }, {
        name: '折扣券',
        value: 2
      }, {
        name: '现金券',
        value: 3
      }, {
        name: '单升券',
        value: 4
      }],
      stepActive: 1,
      multipleSelection: [],
      addFullReduceDialogVisible: false,
      viewFullReduceDialogVisible: false,
      addDiscountDialogVisible: false,
      viewDiscountDialogVisible: false,
      addCashDialogVisible: false,
      viewCashDialogVisible: false,
      addSingleDiscountDialogVisible: false,
      viewSingleDiscountDialogVisible: false,
      dialogTitle: '',
      dateRangeValueArr: [],
      timeRangeValueArr: ['00:00:00', '23:59:59'],
      weekOptions: [],
      orderMaxCouponNum: 0,
      weekCheckAll: false,
      weekChecked: [],
      stationOptions: [],
      stationCheckAll: false,
      stationIdChecked: [],
      oilCodesOptions: [],
      oilCodesCheckAll: false,
      oilCodesChecked: [],
      formData: {},
      CapitalRelationList: {},
      ticketRuleNoVal: ''
    };
  },
  computed: {},
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示都会调用
              if (_this.$route.params) {
                _this.searchInfo = Object.assign(_this.searchInfo, _this.$route.params);

                _this.getTableData();
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, orderMaxCouponNum, stationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                debugger;
                that = _this3;
                getCapitalRelationList({
                  'page': 1,
                  'pageSize': 999
                }).then(function (res) {
                  if (res.code == 0) {
                    that.CapitalRelationList = res.data.list;
                    console.log(that.CapitalRelationList);
                  }
                });
                _context3.next = 5;
                return that.getDict('oilCode');

              case 5:
                that.oilCodesOptions = _context3.sent;
                _context3.next = 8;
                return that.getDict('week');

              case 8:
                that.weekOptions = _context3.sent;
                orderMaxCouponNum = [];
                _context3.next = 12;
                return that.getDict('OrderMaxCouponNum');

              case 12:
                orderMaxCouponNum = _context3.sent;
                orderMaxCouponNum.forEach(function (item) {
                  if (item.label == 'oilOrderMaxCouponNum') {
                    that.orderMaxCouponNum = item.value;
                  }
                });
                _context3.next = 16;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 16:
                stationOptions = _context3.sent;
                that.stationOptions = stationOptions.data.list;
                that.formData = that.initData();
                that.searchInfo.ruleType = that.ruleType;

                if (_this.$route.params) {
                  _this.searchInfo = Object.assign(_this.searchInfo, _this.$route.params);
                }

                that.getTableData();

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        ruleType: this.ruleType,
        // 油品券
        ticketType: 0,
        // 1=满减 2=折扣
        ruleStatus: 1,
        // 0=关闭  1=启用
        ticketName: '',
        describe: '',
        ticketValue: '',
        maxDiscountValue: 0,
        limitSales: 1,
        limitSalesValue: 0,
        limitSellers: 1,
        limitGoods: 1,
        limitAddDiscount: 0,
        limitAddTicket: 0,
        addTicketNum: 1,
        limitReceive: 0,
        limitFirstUse: 0,
        ticketTimeType: 0,
        dateStart: '',
        dateEnd: '',
        timeStart: '',
        timeEnd: '',
        limitDays: '',
        circleWeek: '',
        remark: '',
        ticketGoodsRule: [],
        ticketSellerRule: [],
        isCapital: 0,
        ticketDiscountCapitalRule: [this.initTicketSingle()]
      };
      return formdata;
    },
    initTicketSingle: function initTicketSingle() {
      return {
        capitalId: '',
        capitalValue: 100,
        capitalType: 1,
        discountType: 2,
        // 油品券2 便利店商品券3
        remark: '按比例出资'
      };
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.ruleType = this.ruleType;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.searchInfo.ruleType = this.ruleType;
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 下一步
    addNext: function addNext() {
      debugger;

      if (!this.capitalValueChecking()) {
        return;
      }

      if (this.stepActive < 3) {
        this.stepActive++;
      }
    },
    // 上一步
    addBefore: function addBefore() {
      if (this.stepActive > 1) {
        this.stepActive--;
      }
    },
    // 星期全选
    handleCheckWeekAllChange: function handleCheckWeekAllChange(val) {
      this.weekChecked = val ? this.weekOptions.map(function (w) {
        return w.value;
      }) : [];
      this.weekCheckAll = this.weekChecked.length === this.weekOptions.length;
      this.getDescribe();
    },
    handleCheckedWeekChange: function handleCheckedWeekChange(value) {
      this.weekCheckAll = value.length === this.weekOptions.length;

      if (this.weekCheckAll) {
        this.handleCheckWeekAllChange(true);
      }

      this.getDescribe();
    },
    // 油站全选
    handleStationCheckAllChange: function handleStationCheckAllChange(val) {
      this.stationIdChecked = val ? this.stationOptions.map(function (w) {
        return w.ID;
      }) : [];
      this.stationCheckAll = this.stationIdChecked.length === this.stationOptions.length;
      this.getDescribe();
    },
    handleCheckedStationChange: function handleCheckedStationChange(value) {
      this.stationCheckAll = value.length === this.stationOptions.length;

      if (this.stationCheckAll) {
        this.handleCheckStationAllChange(true);
      }

      this.getDescribe();
    },
    // 油品全选
    handleCheckOilCodeAllChange: function handleCheckOilCodeAllChange(val) {
      this.oilCodesChecked = val ? this.oilCodesOptions.map(function (w) {
        return w.value;
      }) : [];
      this.oilCodesCheckAll = this.oilCodesChecked.length === this.oilCodesOptions.length;
      this.getDescribe();
    },
    handleCheckedOilCodeChange: function handleCheckedOilCodeChange(value) {
      this.oilCodesCheckAll = value.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.handleCheckOilCodeAllChange(true);
      }

      this.getDescribe();
    },
    // 新增
    onAdd: function onAdd(ticketType) {
      var that = this; // 满减券

      if (ticketType == 1) {
        that.type = 'addFullReduce';
        that.addFullReduceDialogVisible = true;
        that.dialogTitle = '新增满减券';
      } // 满折券


      if (ticketType == 2) {
        that.type = 'addDiscount';
        that.addDiscountDialogVisible = true;
        that.dialogTitle = '新增满折券';
      } // 现金券


      if (ticketType == 3) {
        that.type = 'addCash';
        that.formData.limitAddDiscount = 1;
        that.formData.limitAddTicket = 1;
        that.formData.limitSales = 0;
        that.addCashDialogVisible = true;
        that.dialogTitle = '新增现金券';
      } // 单升券


      if (ticketType == 4) {
        that.type = 'addSingleDiscount';
        that.formData.limitAddDiscount = 0;
        that.formData.limitAddTicket = 0;
        that.addSingleDiscountDialogVisible = true;
        that.dialogTitle = '新增单升券';
      }

      that.formData.ticketType = ticketType;
      that.getDescribe();
    },
    // 选择
    capitaChange: function capitaChange(item) {
      for (var i = 0; i < this.CapitalRelationList.length; i++) {
        if (this.CapitalRelationList[i].capitalId == item) {
          for (var j = 0; j < this.formData.ticketDiscountCapitalRule.length; j++) {
            if (this.formData.ticketDiscountCapitalRule[j].capitalId == item) {
              this.formData.ticketDiscountCapitalRule[j].capitalName = this.CapitalRelationList[i].capitalName;
              this.formData.ticketDiscountCapitalRule[j].capitalNo = this.CapitalRelationList[i].capitalNo;
            }
          }
        }
      }
    },
    // 添加
    onAddTicket: function onAddTicket(index) {
      var that = this;
      that.formData.ticketDiscountCapitalRule.splice(index + 1, 0, that.initTicketSingle());
    },
    // 删除
    onDeleteTicket: function onDeleteTicket(index) {
      debugger;
      var that = this;

      if (that.formData.ticketDiscountCapitalRule.length == 1) {
        return;
      }

      that.formData.ticketDiscountCapitalRule.splice(index, 1);
    },
    // 查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    onView: function onView(row) {
      var that = this;

      if (row.ticketType == 1) {
        that.type = 'viewFullReduce';
        this.dialogTitle = '查看满减券';
        this.viewFullReduceDialogVisible = true;
      }

      if (row.ticketType == 2) {
        that.type = 'viewDiscount';
        this.dialogTitle = '查看满折券';
        this.viewDiscountDialogVisible = true;
      }

      if (row.ticketType == 3) {
        that.type = 'viewCash';
        this.dialogTitle = '查看现金券';
        this.viewCashDialogVisible = true;
      }

      if (row.ticketType == 4) {
        that.type = 'viewSingleDiscount';
        this.dialogTitle = '查看单升券';
        this.viewSingleDiscountDialogVisible = true;
      }

      this.handleViewOrUpdate(row);
    },
    onViewSeller: function onViewSeller(row) {
      this.onView(row);
      this.stepActive = 2;
    },
    onViewGoods: function onViewGoods(row) {
      this.onView(row);
      this.stepActive = 3;
    },
    // 变更
    onUpdate: function onUpdate(row) {
      var that = this;

      if (row.ticketType == 1) {
        that.type = 'updateFullReduce';
        that.addFullReduceDialogVisible = true;
        that.dialogTitle = '变更满减券';
      }

      if (row.ticketType == 2) {
        that.type = 'updateDiscount';
        that.addDiscountDialogVisible = true;
        that.dialogTitle = '变更折扣券';
      }

      if (row.ticketType == 3) {
        that.type = 'updateCash';
        that.formData.limitAddDiscount = 1;
        that.formData.limitAddTicket = 1;
        that.addCashDialogVisible = true;
        that.dialogTitle = '变更现金券';
      }

      if (row.ticketType == 4) {
        that.type = 'updateSingleDiscount';
        that.addSingleDiscountDialogVisible = true;
        that.dialogTitle = '变更单升券';
      }

      that.handleViewOrUpdate(row);
      that.$forceUpdate();
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      var that = this;
      getTicketRuleDetail({
        'ticketRuleNo': row.ticketRuleNo
      }).then(function (res) {
        var formData = res.data;
        that.oilCodesChecked = [];
        that.stationIdChecked = [];
        that.weekChecked = []; // 不能用以下写法，回显会不展示
        // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.startTime)
        // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.endTime)

        formData.dateStart = that.$options.filters.formatDate(formData.dateStart, 'yyyy-MM-dd');
        formData.dateEnd = that.$options.filters.formatDate(formData.dateEnd, 'yyyy-MM-dd');
        that.dateRangeValueArr = [formData.dateStart, formData.dateEnd];
        that.timeRangeValueArr = [formData.timeStart, formData.timeEnd];

        if (formData.limitGoods == 1) {
          formData.ticketGoodsRule.forEach(function (item) {
            that.oilCodesChecked.push(parseInt(item.limitGoods));
          });
          that.oilCodesCheckAll = that.oilCodesChecked.length == that.oilCodesOptions;
        }

        if (formData.limitSellers == 1) {
          formData.ticketSellerRule.forEach(function (item) {
            that.stationIdChecked.push(item.sellerId);
          });
          that.stationCheckAll = that.stationIdChecked == that.stationOptions;
        }

        if (formData.isCapital == 1 && formData.ticketDiscountCapitalRule) {
          for (var j = 0; j < formData.ticketDiscountCapitalRule.length; j++) {
            formData.ticketDiscountCapitalRule[j].capitalValue = formData.ticketDiscountCapitalRule[j].capitalValue * 100;
          }
        } else {
          formData.ticketDiscountCapitalRule = [that.initTicketSingle()];
        }

        formData.circleWeek.split(',').forEach(function (item) {
          that.weekChecked.push(parseInt(item));
        });
        that.weekCheckAll = that.weekChecked.length == that.weekOptions.length;
        formData.ticketGoodsRule = [];
        formData.ticketSellerRule = [];
        that.formData = formData;
      }, function (error) {});
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      deleteTicketRule({
        'ticketRuleNo': row.ticketRuleNo
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    closeDialog: function closeDialog() {
      this.stepActive = 1;
      this.addFullReduceDialogVisible = false;
      this.viewFullReduceDialogVisible = false;
      this.addDiscountDialogVisible = false;
      this.viewDiscountDialogVisible = false;
      this.addCashDialogVisible = false;
      this.viewCashDialogVisible = false;
      this.addSingleDiscountDialogVisible = false;
      this.viewSingleDiscountDialogVisible = false;
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.timeRangeValueArr = ['00:00:00', '23:59:59'];
      this.weekChecked = [];
      this.weekCheckAll = false;
      this.stationCheckAll = false;
      this.stationIdChecked = [];
      this.oilCodesCheckAll = false;
      this.oilCodesChecked = [];
      this.formData = this.initData();
    },
    // 验证出资方
    capitalValueChecking: function capitalValueChecking() {
      var capitalValue = 0;

      if (this.formData.isCapital == 0) {
        return true;
      }

      for (var j = 0; j < this.formData.ticketDiscountCapitalRule.length; j++) {
        if (this.formData.ticketDiscountCapitalRule[j].capitalId == '') {
          this.$message({
            type: 'warning',
            message: '请选择出资方'
          });
          return false;
        }
      }

      for (var _j = 0; _j < this.formData.ticketDiscountCapitalRule.length; _j++) {
        capitalValue += this.formData.ticketDiscountCapitalRule[_j].capitalValue;
      }

      if (capitalValue != 100) {
        this.$message({
          type: 'warning',
          message: '出资占比合计需要等于100%'
        });
        return false;
      }

      return true;
    },
    onDialogSubmit: function onDialogSubmit() {
      if (!this.capitalValueChecking()) {
        return;
      }

      var that = this;
      debugger;

      switch (that.type) {
        case 'addFullReduce':
          that.handleAdd();
          break;

        case 'updateFullReduce':
          that.handleUpdate();
          break;

        case 'addDiscount':
          that.handleAdd();
          break;

        case 'updateDiscount':
          that.handleUpdate();
          break;

        case 'addCash':
          that.handleAdd();
          break;

        case 'updateCash':
          that.handleUpdate();
          break;

        case 'addSingleDiscount':
          that.handleAdd();
          break;

        case 'updateSingleDiscount':
          that.handleUpdate();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;

                if (that.validFormData()) {
                  createTicketRule(that.getParam()).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                }

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;

                if (that.validFormData()) {
                  updateTicketRule(that.getParam()).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                }

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 公共校验函数
    validFormData: function validFormData() {
      debugger;
      var that = this;

      if (!that.formData.ticketName || !that.formData.ticketName.trim()) {
        that.$message({
          type: 'warning',
          message: '券名称不能为空'
        });
        return false;
      }

      if (that.formData.ticketValue <= 0 || that.formData.ticketValue == '') {
        that.$message({
          type: 'warning',
          message: '券面额不能为空'
        });
        return false;
      }

      if (that.addDiscountDialogVisible && that.formData.ticketValue > 1) {
        that.$message({
          type: 'warning',
          message: '折扣券面额不能大于1'
        });
        return false;
      }

      if (that.formData.ticketTimeType == 0 && that.dateRangeValueArr.length != 2) {
        that.$message({
          type: 'warning',
          message: '有效日期不能为空'
        });
        return false;
      }

      if (that.formData.ticketTimeType == 1 && (that.formData.limitDays == '' || that.formData.limitDays <= 0)) {
        that.$message({
          type: 'warning',
          message: '有效天数不能为空'
        });
        return false;
      }

      if (that.timeRangeValueArr.length != 2) {
        that.$message({
          type: 'warning',
          message: '每天时间不能为空'
        });
        return false;
      }

      if (that.weekChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '每周时间不能为空'
        });
        return false;
      }

      if (that.formData.limitSellers == 1 && that.stationIdChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '活动油站不能为空'
        });
        return false;
      }

      if (that.formData.limitGoods == 1 && that.oilCodesChecked.length == 0) {
        that.$message({
          type: 'warning',
          message: '活动油品不能为空'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      debugger;
      var that = this;
      var param = JSON.parse(JSON.stringify(that.formData));

      if (param.ticketTimeType == 0) {
        param.dateStart = that.dateRangeValueArr[0] + ' 00:00:00';
        param.dateEnd = that.dateRangeValueArr[1] + ' 23:59:59';
      }

      param.timeStart = that.timeRangeValueArr[0];
      param.timeEnd = that.timeRangeValueArr[1];

      if (param.limitGoods == 1) {
        that.oilCodesChecked.forEach(function (item) {
          param.ticketGoodsRule.push({
            'limitType': 1,
            'limitGoods': item + ''
          });
        });
      }

      if (param.limitSellers == 1) {
        that.stationIdChecked.forEach(function (item) {
          param.ticketSellerRule.push({
            'sellerId': parseInt(item)
          });
        });
      }

      if (param.isCapital == 1) {
        for (var j = 0; j < param.ticketDiscountCapitalRule.length; j++) {
          param.ticketDiscountCapitalRule[j].capitalValue = param.ticketDiscountCapitalRule[j].capitalValue / 100;
        }
      }

      param.circleWeek = that.weekChecked.join(',');
      return param;
    },
    getDescribe: function getDescribe() {
      debugger;
      var that = this;
      var describe = []; // 通用券

      if (that.formData.ruleType == 1) {
        if (that.formData.limitSales == 1) {
          describe.push('订单满' + that.formData.limitSalesValue + '元可用');
        }

        if (that.formData.limitSales == 2) {
          describe.push('加油满' + that.formData.limitSalesValue + '升可用，或商品满' + that.formData.limitSalesValue + '件可用');
        }

        if (that.formData.limitSellers == 0) {
          describe.push('全部油站和便利店可用');
        }

        if (that.formData.limitSellers == 1) {
          describe.push('限部分油站和便利店使用');
        }

        if (that.formData.limitGoods == 0) {
          describe.push('全部油品和商品可用');
        }

        if (that.formData.limitGoods == 1) {
          describe.push('限部分油品和商品使用');
        }
      } // 油品券


      if (that.formData.ruleType == 2) {
        if (that.formData.limitSales == 1) {
          describe.push('加油满' + that.formData.limitSalesValue + '元可用');
        }

        if (that.formData.limitSales == 2) {
          describe.push('加油满' + that.formData.limitSalesValue + '升可用');
        }

        if (that.formData.limitSellers == 0) {
          describe.push('全部油站可用');
        }

        if (that.formData.limitSellers == 1) {
          describe.push('限部分油站可用');
        }

        if (that.formData.limitGoods == 0) {
          describe.push('全部油品可用');
        }

        if (that.formData.limitGoods == 1) {
          describe.push(that.oilCodesCheckAll ? '全部油品可用' : '限' + that.$options.filters.getOilCodeNames(that.oilCodesChecked.join(',')) + '使用');
        }
      }

      if (that.formData.ticketType == 2 || that.formData.ticketType == 4) {
        describe.push('最高优惠' + that.formData.maxDiscountValue + '元');
      }

      if (that.formData.limitAddDiscount == 0) {
        describe.push('不与会员优惠叠加');
      }

      if (that.formData.limitAddDiscount == 1) {
        describe.push('可与会员优惠叠加(特定活动除外)');
      }

      if (that.formData.limitAddTicket == 0) {
        describe.push('不能叠加任何券');
      }

      if (that.formData.limitAddTicket == 1) {
        if (that.formData.ticketType == 1) {
          describe.push('可叠加任何满减券、现金券,最多叠加' + that.orderMaxCouponNum + '张');
        }

        if (that.formData.ticketType == 2) {
          describe.push('可叠加任何折扣券、现金券,最多叠加' + that.orderMaxCouponNum + '张');
        }

        if (that.formData.ticketType == 3) {
          describe.push('可叠加任何券,最多叠加' + that.orderMaxCouponNum + '张');
        }

        if (that.formData.ticketType == 4) {
          describe.push('可叠加任何单升券、现金券,最多叠加' + that.orderMaxCouponNum + '张');
        }
      }

      if (that.formData.limitAddTicket == 2) {
        describe.push('只能与本券叠加,最多叠加' + that.formData.addTicketNum + '张');
      }

      if (that.formData.limitFirstUse == 1) {
        describe.push('限首单使用');
      }

      if (that.timeRangeValueArr.length == 2 && that.timeRangeValueArr[0] != '00:00:00' && that.timeRangeValueArr[1] != '23:59:59') {
        describe.push('限每天' + that.timeRangeValueArr[0] + '~' + that.timeRangeValueArr[1] + '使用');
      }

      if (that.weekChecked.length < 7) {
        describe.push('限' + that.$options.filters.getWeekNames(that.weekChecked.join(',')) + '使用');
      }

      var resultDescribe = '';

      for (var i = 1; i <= describe.length; i++) {
        resultDescribe += i + '、' + describe[i - 1] + '\n';
      }

      that.formData.describe = resultDescribe;
    }
  }
};